// LLM generated - Model Claude 4 Sonnet
import { useContext } from 'react';
import { showNotification } from '@mantine/notifications';
import { useQuery } from '@tanstack/react-query';

import { UserContext } from '~/components/providers/UserProvider';

import { getWalletRefundableBreakdown } from '../../../services/wallet/wallet.service.api';

import { PAYMENTS_QUERY_STALE_TIME } from './consts';

type UseWalletRefundableBreakdownProps = {
  enabled?: boolean;
};

export function useWalletRefundableBreakdown({
  enabled = true,
}: UseWalletRefundableBreakdownProps = {}) {
  const { user } = useContext(UserContext);
  const isEnabled = !!user && enabled && window.location.pathname !== '/logout';

  const query = useQuery({
    queryKey: ['wallets/refundable-breakdown', user?.id],
    queryFn: async () => {
      const response = await getWalletRefundableBreakdown();
      return response.data;
    },
    enabled: isEnabled,
    staleTime: PAYMENTS_QUERY_STALE_TIME,
    onError: () => {
      showNotification({
        title: 'Refundable Balance Unavailable',
        message: 'Your refundable balance breakdown is temporarily unavailable.',
        color: 'red',
        autoClose: 5000,
      });
    },
  });

  return { ...query, enabled: isEnabled };
}
